import { Check, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { TargetareListaPropunere } from "@/types/targetare";

type Props = {
  propunere: TargetareListaPropunere;
  ocupat: boolean;
  onDecide: (propunere: TargetareListaPropunere, cui: string | null) => void;
};

export function PropunereCard({ propunere, ocupat, onDecide }: Props) {
  return (
    <div className="space-y-2 rounded-md border p-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="min-w-0">
          <span className="font-medium">{propunere.denumire}</span>
          {propunere.judet && (
            <span className="ml-2 text-xs text-muted-foreground">
              {propunere.judet}
            </span>
          )}
        </div>
        <span
          className="max-w-[50%] truncate text-xs text-muted-foreground"
          title={propunere.nume_fisier}
        >
          {propunere.nume_fisier}
        </span>
      </div>
      <ul className="space-y-1">
        {propunere.candidati.map((c) => (
          <li
            key={c.cui}
            className="flex items-center justify-between gap-2 rounded bg-muted/40 px-2 py-1 text-sm"
          >
            <div className="min-w-0">
              <span className="font-medium">{c.denumire}</span>
              <span className="ml-2 font-mono text-xs">{c.cui}</span>
              <span className="ml-2 text-xs text-muted-foreground">
                {[c.judet, c.localitate].filter(Boolean).join(", ")}
              </span>
              {!c.activa && (
                <Badge variant="outline" className="ml-2 text-xs">
                  inactivă
                </Badge>
              )}
            </div>
            <Button
              size="sm"
              variant="outline"
              disabled={ocupat}
              onClick={() => onDecide(propunere, c.cui)}
            >
              <Check className="mr-1 h-3 w-3" />
              Alege
            </Button>
          </li>
        ))}
      </ul>
      <div className="flex justify-end">
        <Button
          size="sm"
          variant="ghost"
          disabled={ocupat}
          onClick={() => onDecide(propunere, null)}
        >
          <X className="mr-1 h-3 w-3" />
          Nu se potrivește
        </Button>
      </div>
    </div>
  );
}
